import { GridType } from '../models';

export const STANDARD_MENU = 'Standard Menu';
export const MENU_ID = 'MENU_ID';

export const DEFAULT_GRID_SIZES = {
  [GridType.PRODUCTS]: {
    rows: 5,
    columns: 5,
  },
  [GridType.OPTIONS]: {
    columns: 5,
    rows: 3,
  },
};
